import { useCallback, useEffect, useState } from 'react';
export default function useAgentConfig(agentId) {
    const [config, setConfig] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const fetchConfig = useCallback(() => {
        if (!agentId) {
            setConfig(null);
            // Don't set error - agentId might be resolving from storeId
            setError(null);
            return;
        }
        setLoading(true);
        setError(null);
        setConfig(null);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const embedBase = window.__LK_EMBED_BASE__;
        const base = embedBase || window.location.origin;
        const url = new URL(`/api/agents`, base);
        url.searchParams.set('id', agentId);
        fetch(url.toString(), { cache: 'no-store' })
            .then(async (res) => {
            if (!res.ok) {
                const body = await res.json().catch(() => ({}));
                const msg = typeof (body === null || body === void 0 ? void 0 : body.error) === 'string'
                    ? body.error
                    : `Agent config responded ${res.status}`;
                throw new Error(msg);
            }
            return res.json();
        })
            .then((data) => {
            var _a, _b;
            const t = normalizeAgentType(data.agent_type);
            const cfg = {
                id: data.id,
                name: (_a = data.name) !== null && _a !== void 0 ? _a : undefined,
                agentType: t,
                settings: data.settings,
                appearance: (_b = data.appearance) !== null && _b !== void 0 ? _b : undefined,
            };
            setConfig(cfg);
        })
            .catch((err) => {
            console.error('Error fetching agent config:', err);
            setError(err instanceof Error ? err.message : 'Failed to get agent config');
        })
            .finally(() => setLoading(false));
    }, [agentId]);
    useEffect(() => {
        fetchConfig();
    }, [fetchConfig]);
    return { config, loading, error, refresh: fetchConfig };
}
function normalizeAgentType(input) {
    switch ((input || '').toLowerCase()) {
        case 'chat':
            return 'chat';
        case 'voice':
            return 'voice';
        case 'hybrid':
            return 'hybrid';
        default:
            // Default to hybrid to allow both experiences if unknown
            return 'hybrid';
    }
}
